export class NxiNavigation {
    parentPage: any;
    childPage: any;
    grandchildPage: any;
    fourthchildPage: any;
    constructor(parent?: any, child?: any, grandchild?: any, fourthchild?: any) {
        this.parentPage = parent;
        this.childPage = child;
        this.grandchildPage = grandchild;
        this.fourthchildPage = fourthchild;
    }
}
